import { render, staticRenderFns } from "./RequestByProduct.vue?vue&type=template&id=815c27dc&scoped=true&"
import script from "./RequestByProduct.vue?vue&type=script&lang=js&"
export * from "./RequestByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815c27dc",
  null
  
)

export default component.exports